import { LegalLayout, H2 } from "@/pages/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p>
        Your Varsity Application ("YVA") respects your privacy and is committed to protecting your
        personal information in accordance with the Protection of Personal Information Act (POPIA) of
        South Africa. This policy explains what we collect, why, and how we protect it.
      </p>

      <H2>1. Information We Collect</H2>
      <p>
        We collect the information you provide, including your name, email address, password (stored
        securely as an encrypted hash), academic marks, contact and residential details, previous
        school details, next-of-kin details, and application preferences.
      </p>

      <H2>2. How We Use Your Information</H2>
      <p>
        We use your information to calculate your APS, match you to qualifying courses, process your
        payments, and submit university applications on your behalf. We may contact you with updates
        about your applications.
      </p>

      <H2>3. Payments</H2>
      <p>
        Payment processing is handled by Paystack. We do not store or have access to your full card
        details. Only a payment reference and status are retained for record-keeping.
      </p>

      <H2>4. Sharing of Information</H2>
      <p>
        We share your application information only with the university you choose to apply to, and with
        service providers strictly necessary to deliver our service (such as our payment processor). We
        never sell your personal information.
      </p>

      <H2>5. Data Security</H2>
      <p>
        Passwords are hashed using industry-standard encryption. Access to your data is restricted and
        transmitted over secure connections.
      </p>

      <H2>6. Your Rights</H2>
      <p>
        Under POPIA you have the right to access, correct, or request deletion of your personal
        information. Contact us through your account to exercise these rights.
      </p>

      <H2>7. Retention</H2>
      <p>We retain your information for as long as necessary to provide the service and meet legal obligations.</p>

      <H2>8. Contact</H2>
      <p>For any privacy questions, please reach out via your account dashboard.</p>
    </LegalLayout>
  );
}
